import React, { useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';

import { GoogleReCaptcha, TextArea } from 'components/Form/Fields';
import { SubmitButton } from 'components/Form/Buttons';
import useIsUserAuthenticated from 'utils/hooks/useIsUserAuthenticated';
import usePostFeedback from './usePostFeedback';

const TextFeedbackForm = () => {
  const { postFeedback } = usePostFeedback();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const oReCaptchaFieldRef = useRef();
  const bIsUserAuthenticated = useIsUserAuthenticated();
  const bRequireReCaptcha = !bIsUserAuthenticated && !window.Cypress;

  const validationSchema = yup.object({
    feedback: yup.string().required('Please enter your feedback'),
    ...(bRequireReCaptcha && {
      reCaptchaToken: yup.string().required('Please complete the reCAPTCHA'),
    }),
  });

  const handleSubmit = async (oFormValues) => {
    try {
      const { feedback, reCaptchaToken } = oFormValues;
      await postFeedback(feedback, reCaptchaToken);
      setHasSubmitted(true);
    } catch (oError) {
      console.error('Error submitting feedback:', oError);
    }
  };

  if (hasSubmitted) {
    return (
      <div className='feedback__thanks t-paragraph'>
        Thanks for your feedback!
      </div>
    );
  }

  return (
    <>
      <div className='feedback__header t-paragraph'>How are we doing?</div>
      <Formik
        initialValues={{
          feedback: '',
          reCaptchaToken: window.Cypress ? 'cypress' : '',
        }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        <Form className='textFeedbackForm'>
          <TextArea
            sId='feedback-comments'
            sName='feedback'
            sLabel='Your Feedback'
            className='textFeedbackForm__textArea'
          />
          {!bIsUserAuthenticated && (
            <GoogleReCaptcha
              oReCaptchaRef={oReCaptchaFieldRef}
              className='feedback__recaptcha'
            />
          )}
          <SubmitButton bIsCentered className='feedback__submit' />
        </Form>
      </Formik>
    </>
  );
};

export default TextFeedbackForm;
